import React from "react";
import { Grid, Typography, makeStyles, Box } from "@material-ui/core";

import { Icon } from "../base";
import { COLORS } from "../../theme/colors";

import { formatBytes, formatDatetime } from "../../services";
import DownloadImg from "../../assets/images/settings/doctype/download.svg";
import DocRedImg from "../../assets/images/icons/doc-red.svg";

const useStyle = makeStyles(() => ({
  leftContainer: {
    width: "100%",
    marginLeft: 10,
  },
  name: {
    fontSize: 14,
    color: COLORS.darks[0][100],
    marginBottom: 5,
  },
  info: {
    fontSize: 12,
    color: COLORS.darks[0][50],
    marginBottom: 5,
  },
  extBox: {
    position: "relative",
  },
  ext: {
    position: "absolute",
    bottom: 10,
    left: "50%",
    transform: "translateX(-50%)",
    color: COLORS.white,
    textTransform: "uppercase",
    fontWeight: 700,
  },
  grid: {
    padding: 10,
  },
}));

export const AttachmentCard = ({ item, xs, styles, handleClick }) => {
  const classes = useStyle();

  return (
    <Grid item xs={xs} container alignItems="center" className={classes.grid} style={styles}>
      <Grid item>
        <Box className={classes.extBox}>
          <Icon src={DocRedImg} className={classes.file} />
          <Typography className={classes.ext}>{item.ext}</Typography>
        </Box>
      </Grid>
      <Grid item xs={9} className={classes.leftContainer}>
        <Typography className={classes.name}>{item.name}</Typography>
        <Grid container justifyContent="space-between" alignItems="center">
          <Box>
            <Typography className={classes.info}>
              {formatDatetime(item.created, "MMMM D, YYYY")}
            </Typography>
            <Typography className={classes.info}>{formatBytes(item.size)}</Typography>
          </Box>
          <Icon
            src={DownloadImg}
            onClick={() => handleClick(item)}
            hoverable
            tooltip="Download as xlsx"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
